import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SupabaseService } from '../../supabase/supabase.service';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.css'
})
export class AdminComponent implements OnInit {
  adminName = signal('Admin');

  constructor(private supabaseService: SupabaseService) {}

  ngOnInit() {
    this.loadAdminData();
  }

  private async loadAdminData() {
    const result = await this.supabaseService.getUser();
    const user = result?.data?.user;
    
    if (user && typeof user === 'object' && 'user_metadata' in user) {
      const metadata = (user as any).user_metadata;
      if (metadata?.['display_name']) {
        this.adminName.set(metadata['display_name']);
      }
    }
  }
}

